export default __webpack_public_path__ + "static/heart_in_hand-26646b3ef3d292e30594f5b7d5c1b688.svg";